/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult
} from '@tanstack/react-query';

import { customInstance } from '.././instance';
import type { ErrorType } from '.././instance';
import type {
	ListSentencesParams,
	PraetoidError,
	Sentence,
	SentenceDirectiveEventListResponse,
	SentenceDirectiveListResponse,
	SentenceListResponse
} from '../models';

/**
 * Returns all sentences for a actor within the organization. Draft sentences are excluded.
 * @summary List sentences for a actor
 */
export const listSentences = (params: ListSentencesParams) => {
	return customInstance<SentenceListResponse>({ url: `/sentences`, method: 'GET', params });
};

export const getListSentencesQueryKey = (params?: ListSentencesParams) => {
	return ['sentences', ...(params ? [params] : [])] as const;
};

export const getListSentencesQueryOptions = <
	TData = Awaited<ReturnType<typeof listSentences>>,
	TError = ErrorType<PraetoidError>
>(
	params: ListSentencesParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSentences>>, TError, TData>>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListSentencesQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof listSentences>>> = () =>
		listSentences(params);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listSentences>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSentencesQueryResult = NonNullable<Awaited<ReturnType<typeof listSentences>>>;
export type ListSentencesQueryError = ErrorType<PraetoidError>;

export function useListSentences<
	TData = Awaited<ReturnType<typeof listSentences>>,
	TError = ErrorType<PraetoidError>
>(
	params: ListSentencesParams,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSentences>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listSentences>>,
					TError,
					Awaited<ReturnType<typeof listSentences>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSentences<
	TData = Awaited<ReturnType<typeof listSentences>>,
	TError = ErrorType<PraetoidError>
>(
	params: ListSentencesParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSentences>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listSentences>>,
					TError,
					Awaited<ReturnType<typeof listSentences>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSentences<
	TData = Awaited<ReturnType<typeof listSentences>>,
	TError = ErrorType<PraetoidError>
>(
	params: ListSentencesParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSentences>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List sentences for a actor
 */

export function useListSentences<
	TData = Awaited<ReturnType<typeof listSentences>>,
	TError = ErrorType<PraetoidError>
>(
	params: ListSentencesParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSentences>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getListSentencesQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns a single sentence with all directives. Draft sentences are not accessible.
 * @summary Get a sentence by ID
 */
export const getSentence = (id: string) => {
	return customInstance<Sentence>({ url: `/sentences/${id}`, method: 'GET' });
};

export const getGetSentenceQueryKey = (id: string) => {
	return ['sentences', id] as const;
};

export const getGetSentenceQueryOptions = <
	TData = Awaited<ReturnType<typeof getSentence>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSentence>>, TError, TData>>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetSentenceQueryKey(id);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getSentence>>> = () => getSentence(id);

	return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getSentence>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSentenceQueryResult = NonNullable<Awaited<ReturnType<typeof getSentence>>>;
export type GetSentenceQueryError = ErrorType<PraetoidError>;

export function useGetSentence<
	TData = Awaited<ReturnType<typeof getSentence>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSentence>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getSentence>>,
					TError,
					Awaited<ReturnType<typeof getSentence>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSentence<
	TData = Awaited<ReturnType<typeof getSentence>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSentence>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getSentence>>,
					TError,
					Awaited<ReturnType<typeof getSentence>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSentence<
	TData = Awaited<ReturnType<typeof getSentence>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSentence>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a sentence by ID
 */

export function useGetSentence<
	TData = Awaited<ReturnType<typeof getSentence>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSentence>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetSentenceQueryOptions(id, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Accepts a proposed sentence, activating each directive on its own clock.
 * @summary Accept a proposed sentence
 */
export const acceptSentence = (id: string) => {
	return customInstance<Sentence>({ url: `/sentences/${id}/accept`, method: 'POST' });
};

export const getAcceptSentenceMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof acceptSentence>>,
		TError,
		{ id: string },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof acceptSentence>>,
	TError,
	{ id: string },
	TContext
> => {
	const mutationKey = ['acceptSentence'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptSentence>>, { id: string }> = (
		props
	) => {
		const { id } = props ?? {};

		return acceptSentence(id);
	};

	return { mutationFn, ...mutationOptions };
};

export type AcceptSentenceMutationResult = NonNullable<Awaited<ReturnType<typeof acceptSentence>>>;

export type AcceptSentenceMutationError = ErrorType<PraetoidError>;

/**
 * @summary Accept a proposed sentence
 */
export const useAcceptSentence = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof acceptSentence>>,
			TError,
			{ id: string },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof acceptSentence>>,
	TError,
	{ id: string },
	TContext
> => {
	return useMutation(getAcceptSentenceMutationOptions(options), queryClient);
};
/**
 * Revokes every non-terminal directive on an accepted sentence before it expires (the sentence-wide pardon).
 * @summary Pardon an accepted sentence
 */
export const pardonSentence = (id: string) => {
	return customInstance<Sentence>({ url: `/sentences/${id}/decide`, method: 'POST' });
};

export const getPardonSentenceMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof pardonSentence>>,
		TError,
		{ id: string },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof pardonSentence>>,
	TError,
	{ id: string },
	TContext
> => {
	const mutationKey = ['pardonSentence'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<Awaited<ReturnType<typeof pardonSentence>>, { id: string }> = (
		props
	) => {
		const { id } = props ?? {};

		return pardonSentence(id);
	};

	return { mutationFn, ...mutationOptions };
};

export type PardonSentenceMutationResult = NonNullable<Awaited<ReturnType<typeof pardonSentence>>>;

export type PardonSentenceMutationError = ErrorType<PraetoidError>;

/**
 * @summary Pardon an accepted sentence
 */
export const usePardonSentence = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof pardonSentence>>,
			TError,
			{ id: string },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof pardonSentence>>,
	TError,
	{ id: string },
	TContext
> => {
	return useMutation(getPardonSentenceMutationOptions(options), queryClient);
};
/**
 * Rejects a proposed sentence and voids its directives without enforcing them.
 * @summary Reject a proposed sentence
 */
export const rejectSentence = (id: string) => {
	return customInstance<Sentence>({ url: `/sentences/${id}/reject`, method: 'POST' });
};

export const getRejectSentenceMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof rejectSentence>>,
		TError,
		{ id: string },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof rejectSentence>>,
	TError,
	{ id: string },
	TContext
> => {
	const mutationKey = ['rejectSentence'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectSentence>>, { id: string }> = (
		props
	) => {
		const { id } = props ?? {};

		return rejectSentence(id);
	};

	return { mutationFn, ...mutationOptions };
};

export type RejectSentenceMutationResult = NonNullable<Awaited<ReturnType<typeof rejectSentence>>>;

export type RejectSentenceMutationError = ErrorType<PraetoidError>;

/**
 * @summary Reject a proposed sentence
 */
export const useRejectSentence = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof rejectSentence>>,
			TError,
			{ id: string },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof rejectSentence>>,
	TError,
	{ id: string },
	TContext
> => {
	return useMutation(getRejectSentenceMutationOptions(options), queryClient);
};
/**
 * Revokes an individual directive within a sentence (a pardon). If all directives become terminal, the sentence completes.
 * @summary Revoke a single directive
 */
export const revokeDirective = (sentenceId: string, id: string) => {
	return customInstance<Sentence>({
		url: `/sentences/${sentenceId}/directives/${id}/revoke`,
		method: 'POST'
	});
};

export const getRevokeDirectiveMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof revokeDirective>>,
		TError,
		{ sentenceId: string; id: string },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof revokeDirective>>,
	TError,
	{ sentenceId: string; id: string },
	TContext
> => {
	const mutationKey = ['revokeDirective'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof revokeDirective>>,
		{ sentenceId: string; id: string }
	> = (props) => {
		const { sentenceId, id } = props ?? {};

		return revokeDirective(sentenceId, id);
	};

	return { mutationFn, ...mutationOptions };
};

export type RevokeDirectiveMutationResult = NonNullable<
	Awaited<ReturnType<typeof revokeDirective>>
>;

export type RevokeDirectiveMutationError = ErrorType<PraetoidError>;

/**
 * @summary Revoke a single directive
 */
export const useRevokeDirective = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof revokeDirective>>,
			TError,
			{ sentenceId: string; id: string },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof revokeDirective>>,
	TError,
	{ sentenceId: string; id: string },
	TContext
> => {
	return useMutation(getRevokeDirectiveMutationOptions(options), queryClient);
};
/**
 * Returns the append-only ledger feed for a sentence's directives. Detail-view surface only — the activity feed relies on the case timeline.
 * @summary Get the directive ledger for a sentence
 */
export const syncSentenceDirectiveEvents = (id: string) => {
	return customInstance<SentenceDirectiveEventListResponse>({
		url: `/sync/sentences/${id}/directive-events`,
		method: 'GET'
	});
};

export const getSyncSentenceDirectiveEventsQueryKey = (id: string) => {
	return ['sync', 'sentences', id, 'directive-events'] as const;
};

export const getSyncSentenceDirectiveEventsQueryOptions = <
	TData = Awaited<ReturnType<typeof syncSentenceDirectiveEvents>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof syncSentenceDirectiveEvents>>, TError, TData>
		>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getSyncSentenceDirectiveEventsQueryKey(id);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof syncSentenceDirectiveEvents>>> = () =>
		syncSentenceDirectiveEvents(id);

	return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof syncSentenceDirectiveEvents>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SyncSentenceDirectiveEventsQueryResult = NonNullable<
	Awaited<ReturnType<typeof syncSentenceDirectiveEvents>>
>;
export type SyncSentenceDirectiveEventsQueryError = ErrorType<PraetoidError>;

export function useSyncSentenceDirectiveEvents<
	TData = Awaited<ReturnType<typeof syncSentenceDirectiveEvents>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof syncSentenceDirectiveEvents>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof syncSentenceDirectiveEvents>>,
					TError,
					Awaited<ReturnType<typeof syncSentenceDirectiveEvents>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSyncSentenceDirectiveEvents<
	TData = Awaited<ReturnType<typeof syncSentenceDirectiveEvents>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof syncSentenceDirectiveEvents>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof syncSentenceDirectiveEvents>>,
					TError,
					Awaited<ReturnType<typeof syncSentenceDirectiveEvents>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSyncSentenceDirectiveEvents<
	TData = Awaited<ReturnType<typeof syncSentenceDirectiveEvents>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof syncSentenceDirectiveEvents>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the directive ledger for a sentence
 */

export function useSyncSentenceDirectiveEvents<
	TData = Awaited<ReturnType<typeof syncSentenceDirectiveEvents>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof syncSentenceDirectiveEvents>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getSyncSentenceDirectiveEventsQueryOptions(id, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns the directives issued on a sentence with their lifecycle status and enforcement timestamps.
 * @summary Get directives for a sentence
 */
export const syncSentenceDirectives = (id: string) => {
	return customInstance<SentenceDirectiveListResponse>({
		url: `/sync/sentences/${id}/directives`,
		method: 'GET'
	});
};

export const getSyncSentenceDirectivesQueryKey = (id: string) => {
	return ['sync', 'sentences', id, 'directives'] as const;
};

export const getSyncSentenceDirectivesQueryOptions = <
	TData = Awaited<ReturnType<typeof syncSentenceDirectives>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof syncSentenceDirectives>>, TError, TData>
		>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getSyncSentenceDirectivesQueryKey(id);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof syncSentenceDirectives>>> = () =>
		syncSentenceDirectives(id);

	return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof syncSentenceDirectives>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SyncSentenceDirectivesQueryResult = NonNullable<
	Awaited<ReturnType<typeof syncSentenceDirectives>>
>;
export type SyncSentenceDirectivesQueryError = ErrorType<PraetoidError>;

export function useSyncSentenceDirectives<
	TData = Awaited<ReturnType<typeof syncSentenceDirectives>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof syncSentenceDirectives>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof syncSentenceDirectives>>,
					TError,
					Awaited<ReturnType<typeof syncSentenceDirectives>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSyncSentenceDirectives<
	TData = Awaited<ReturnType<typeof syncSentenceDirectives>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof syncSentenceDirectives>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof syncSentenceDirectives>>,
					TError,
					Awaited<ReturnType<typeof syncSentenceDirectives>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSyncSentenceDirectives<
	TData = Awaited<ReturnType<typeof syncSentenceDirectives>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof syncSentenceDirectives>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get directives for a sentence
 */

export function useSyncSentenceDirectives<
	TData = Awaited<ReturnType<typeof syncSentenceDirectives>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof syncSentenceDirectives>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getSyncSentenceDirectivesQueryOptions(id, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}
